import React from "react";
import Timer from "../components/form-controls/Timer";

const BookingToast = ({
  // old payload
  enquiryId,
  bookingId,
  tripType,
  pickup,
  dropoff,
  drop,
  customer,
  id,
  travelDateTime,
  travelDate,

  // new payload
  searchId,
  origin,
  destination,
  customerName,
  customerPhone,
  countryCode,
  departureDate,
  pickupTime,
  userType,

  // booking payload additions
  source,
  destinationAddress,

  // common
  message,
  history,
  closeOnClick,
  closeToast,
  bookingType,
  driverId,
  driverPhone,
  driverName,
}) => {
  const resolvedTripType = tripType || bookingType;

  let tripTypeName = "-";

  if (
    resolvedTripType === "bookRide" ||
    resolvedTripType === "outstation" ||
    resolvedTripType === "ONE_WAY" ||
    resolvedTripType === "ROUND_TRIP"
  ) {
    tripTypeName = "Outstation";
  } else if (resolvedTripType === "local") {
    tripTypeName = "Local";
  } else if (resolvedTripType === "hourlyRental") {
    tripTypeName = "Hourly Rental";
  } else {
    tripTypeName = resolvedTripType || "-";
  }
  // enquiry id support
  const enquiryReference = enquiryId || searchId;

  const pickupLocation =
    pickup || source || origin?.address || origin?.city || "-";

  const dropLocation = dropoff || drop || destination || "-";
  // customer support
  const customerDisplayName = customer?.name || customerName || "-";

  const formattedPhone =
    customer?.phone || customerPhone
      ? `${customer?.countryCode || countryCode || ""} - ${
          customer?.phone || customerPhone
        }`
      : "-";

  // datetime support
  const travelDateTimeValue =
    travelDateTime ||
    [travelDate, departureDate, pickupTime].filter(Boolean).join(" ");

  // const redirectToPage = (enquiryReference) => {
  //   return enquiryReference
  //     ? `/bookings/add/${id}?pusherEnq=${enquiryReference}`
  //     : `/bookings/add/${id}`;
  // };

  const redirectToPage = (enquiryReference) => {
    return enquiryReference
      ? `/bookings/addnew/${id}`
      : `/b2bbookings/add/${id}`;
  };

  const redirectToB2BPage = () => {
    return `/b2bbookings/add/${id}`;
  };

  const redirectToDriver = () => {
    return `/users/drivers/corporate-driver/add/${driverId}`;
  };

  const handleButtonClick = () => {
    let destinationRoute;

    if (driverId) {
      destinationRoute = redirectToDriver();
    } else if (bookingType === "OTA" || bookingId ) {
      destinationRoute = redirectToB2BPage();
    } else {
      destinationRoute = enquiryReference
        ? redirectToPage(enquiryReference)
        : redirectToPage("");
    }

    history.push(destinationRoute);

    if (closeOnClick && closeToast) {
      closeToast();
    }
  };

  return (
    <div className="booking-toast">
      {/* USER TYPE */}
      {userType && (
        <div className="row">
          <p className="c-first">
            <strong>User Type</strong>
          </p>
          <p>:</p>
          <p className="c-second">
            {userType === "agent"
              ? "Agent"
              : userType === "customer"
                ? "Customer"
                : userType}
          </p>
        </div>
      )}

      {/* DRIVER */}
      {driverId ? (
        <>
          <div className="row">
            <p className="c-firstr">
              <strong>New Driver Registered</strong>
            </p>
          </div>

          <div className="row">
            <p className="c-first">
              <strong>Driver Name</strong>
            </p>
            <p>:</p>
            <p className="c-second">{driverName}</p>
          </div>

          <div className="row">
            <p className="c-first">
              <strong>Driver Phone</strong>
            </p>
            <p>:</p>
            <p className="c-second">{driverPhone}</p>
          </div>
        </>
      ) : (
        ""
      )}

      {/* OTA */}
      {bookingType === "OTA" ? (
        <div className="row">
          <p className="c-firstr">
            <strong>Reschedule</strong>
          </p>
        </div>
      ) : (
        ""
      )}

      {/* BOOKING / ENQUIRY ID */}
      {bookingId ? (
        <div className="row">
          <p className="c-first">
            <strong>Booking ID</strong>
          </p>
          <p>:</p>
          <p className="c-second">{bookingId}</p>
        </div>
      ) : (
        enquiryReference && (
          <div className="row">
            <p className="c-first">
              <strong>Enquiry ID</strong>
            </p>
            <p>:</p>
            <p className="c-second">{enquiryReference}</p>
          </div>
        )
      )}

      {/* TRIP DETAILS */}
      {!driverId && (
        <>
          <div className="row">
            <p className="c-first">
              <strong>Trip Type</strong>
            </p>
            <p>:</p>
            <p>{tripTypeName}</p>
          </div>

          <div className="row">
            <p className="c-first">
              <strong>Pickup</strong>
            </p>
            <p>:</p>
            <p className="c-second">{pickupLocation}</p>
          </div>

          {tripType === "hourlyRental" ? (
            ""
          ) : (
            <div className="row">
              <p className="c-first">
                <strong>Dropoff</strong>
              </p>
              <p>:</p>
              <p className="c-second">{dropLocation}</p>
            </div>
          )}
        </>
      )}

      {/* DATE TIME */}
      {travelDateTimeValue ? (
        <div className="row">
          <p className="c-first">
            <strong>Date & Time</strong>
          </p>
          <p>:</p>
          <p className="c-second">{travelDateTimeValue}</p>
        </div>
      ) : (
        ""
      )}

      {/* CUSTOMER */}
      {!driverId && (
        <>
          <div className="row">
            <p className="c-first">
              <strong>Name</strong>
            </p>
            <p>:</p>
            <p>{customerDisplayName}</p>
          </div>

          <div className="row">
            <p className="c-first">
              <strong>Phone</strong>
            </p>
            <p>:</p>
            <p>{formattedPhone}</p>
          </div>
        </>
      )}

      {/* MESSAGE */}
      {bookingType === "OTA" || driverId ? (
        ""
      ) : (
        <div className="row">
          <p className="c-first">
            <strong>Message</strong>
          </p>
          <p>:</p>
          <p className="c-second">{message}</p>
        </div>
      )}

      {/* BUTTON */}
      <div className="redirect-button">
        <button onClick={handleButtonClick}>View Details</button>
      </div>

      {/* TIMER */}
      {enquiryReference && (
        <div className="timer-h">
          <Timer />
        </div>
      )}
    </div>
  );
};

export default BookingToast;
